import groupHeaderCommandBarStore from 'owa-group-header-store/lib/store/CommandBarStore';
import GroupHeaderNavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import loadInitialMailTable from './loadInitialMailTable';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
/**
 * Performs the first load for a group table
 * @param tableView - the given mail tableView
 * @param onInitialTableLoadComplete - callback for when the initial table load has completed
 * @param actionSource action that initiated the switch folder action
 * @return a promise that resolves when the load initial table has completed either from server or from cache
 */
export default function loadInitialGroupTable(tableView, onInitialTableLoadComplete, actionSource) {
    // Update SwitchGroup or NavigateFromMeToWe datapoint with
    // information about which group module we are booting into
    var datapoint = returnTopExecutingActionDatapoint();
    var groupModule = groupHeaderCommandBarStore.navigationButtonSelected;
    datapoint &&
        datapoint.addCustomProperty('GroupModule', GroupHeaderNavigationButton[groupModule]);
    // If we are booting into a non-email module, do nothing
    var promiseToReturn = Promise.resolve();
    if (groupModule === GroupHeaderNavigationButton.Email) {
        promiseToReturn = loadInitialMailTable(tableView, onInitialTableLoadComplete, actionSource);
    }
    return promiseToReturn;
}
//# sourceMappingURL=loadInitialGroupTable.js.map